/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bars bunched to one side indicate a skewed distribution.`)
};

const es_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barras agrupadas hacia un lado indican una distribución sesgada.`)
};

const de_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu einer Seite geballte Balken deuten auf eine schiefe Verteilung hin.`)
};

const nl_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staven die aan één kant zijn samengedrukt duiden op een scheve verdeling.`)
};

const fr_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des barres regroupées d'un côté indiquent une distribution asymétrique.`)
};

const it_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre concentrate da un lato indicano una distribuzione asimmetrica.`)
};

const pt_br2_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barras concentradas de um lado indicam uma distribuição assimétrica.`)
};

const pt_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barras concentradas de um lado indicam uma distribuição enviesada.`)
};

const ja_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`棒が片側に偏っている場合、偏った分布であることを示します。`)
};

const zh_hist_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柱子偏向一侧表示偏斜分布。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_ex2", locale)
	if (locale === "en") return en_hist_ex2(inputs)
	if (locale === "es") return es_hist_ex2(inputs)
	if (locale === "de") return de_hist_ex2(inputs)
	if (locale === "nl") return nl_hist_ex2(inputs)
	if (locale === "fr") return fr_hist_ex2(inputs)
	if (locale === "it") return it_hist_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_hist_ex2(inputs)
	if (locale === "pt") return pt_hist_ex2(inputs)
	if (locale === "ja") return ja_hist_ex2(inputs)
	return zh_hist_ex2(inputs)
};